export default "__VITE_ASSET__BzbSZ_d$__"